const COLUNAS = {
  conta: (a, b) =>
    String(a.contaContabil || a.ecdContaContabil || "").localeCompare(
      String(b.contaContabil || b.ecdContaContabil || ""),
      "pt-BR"
    ),
  qtdLancamentos: (a, b) => (a.qtdLancamentos || 0) - (b.qtdLancamentos || 0),
  base: (a, b) => (a.base || 0) - (b.base || 0),
  // Ordena pela Selic mínima do agrupamento (nulos são reordenados ao final em ordenarContas()).
  selic: (a, b) => (a.taxaSelicMin ?? 0) - (b.taxaSelicMin ?? 0),
  baseSelic: (a, b) => (a.baseSelic || 0) - (b.baseSelic || 0),
  pis: (a, b) => (a.pis || 0) - (b.pis || 0),
  cofins: (a, b) => (a.cofins || 0) - (b.cofins || 0),
  // Ordena pelo texto da base legal (contas sem base legal ficam juntas no início).
  baseLegal: (a, b) =>
    String(a.baseLegalDescricao || "").localeCompare(
      String(b.baseLegalDescricao || ""),
      "pt-BR"
    ),
};

/**
 * @param {Array<object>} contas
 * @param {string} coluna
 * @param {'asc'|'desc'} direcao
 */
export function ordenarContas(contas, coluna, direcao = "asc") {
  const cmp = COLUNAS[coluna] || COLUNAS.conta;
  const lista = [...(contas || [])].sort(cmp);
  if (direcao === "desc") lista.reverse();

  if (coluna === "selic") {
    // Nulos sempre ao final, independente da direção (asc ou desc).
    const comValor = lista.filter((c) => c.taxaSelicMin != null);
    const semValor = lista.filter((c) => c.taxaSelicMin == null);
    return [...comValor, ...semValor];
  }

  return lista;
}
